document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('section.units').forEach(section => {
        const modalEl = section.querySelector('.modal');
        if (!modalEl) return;
        const modal = new Modal(modalEl.id || null);

        section.querySelectorAll('.units__tour').forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                const iframe = modalEl.querySelector('.units__iframe');
                if (iframe) iframe.src = btn.dataset.iframeSrc;
                modal.open();
            });
        });
    });
});
